var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',[_c('a',{staticClass:"link-tag",attrs:{"text":""},on:{"click":_vm.onTo}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }